import { render, staticRenderFns } from "./CommunityComment.vue?vue&type=template&id=6b7739f8&scoped=true&"
import script from "./CommunityComment.vue?vue&type=script&lang=js&"
export * from "./CommunityComment.vue?vue&type=script&lang=js&"
import style0 from "./CommunityComment.vue?vue&type=style&index=0&id=6b7739f8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b7739f8",
  null
  
)

export default component.exports